export const INTRO_CONSTANTS = {
  title:
    "Connect Every Corner of Your Enterprise — \nSecure Wired & Wireless Networking By Onemind",
  text: "From high-density office floors to mobile campuses and remote edge sites, OneMind delivers unified, high-performance networking solutions engineered for the modern workplace. ",
};
